import { render, staticRenderFns } from "./ProposalHeader.vue?vue&type=template&id=0480cc96&scoped=true&"
import script from "./ProposalHeader.vue?vue&type=script&lang=js&"
export * from "./ProposalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProposalHeader.vue?vue&type=style&index=0&id=0480cc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480cc96",
  null
  
)

export default component.exports